<!--首页-->
<template>
  <div class="loginBody" v-bind:style="loginHeight" :style="getLoginBg">
    <div class="videoBg" v-if="backgroundIsVideo">
      <!-- 不能动态赋予，否则不会自动运行，没有用到视频的就把src内容移除就行了 -->
      <!--			<video src="../../public/static/unitInformation/loginVideo.mp4" autoplay="autoplay" loop="loop" class="videoPlayer" muted="true">-->
      <!--			</video>-->
    </div>
    <div class="unitTitle">
      <p class="cnTitle">{{title}}</p>
      <div class="qrcodediv">
        <!-- 底部app扫码用的二维码，每个单位可能不一样 -->
        <div class="qrcode">
          <!--					<img src="../../public/static/unitInformation/ORcode.png" />-->
          <p>Android</p>
        </div>
        <div class="qrcode">
          <!--					<img src="../../public/static/unitInformation/weChat.png" />-->
          <p>微信公众号</p>
        </div>
        <div class="qrcode">
          <!--					<img src="../../public/static/unitInformation/ios.png" />-->
          <p>IOS</p>
        </div>
      </div>
    </div>
    <!-- 版权所有 -->
    <div class="information">
      <p>版权所有 © 华普电力有限公司 1998-2017。 保留一切权利。</p>
      <p>渝ICP备17005035号</p>
    </div>
    <div class="loginContent">
      <p class="loginTitle">用户登录</p>
      <p class="loginTitle" style="font-size: 18px;line-height: 20px;">USER&nbsp;&nbsp;&nbsp;&nbsp;LOGIN</p>
      <div class="loginText flexStart">
        <img :src="getResourcesByName('login/username.png')" /><input type="text" name="userCode" v-model="userCode"
          placeholder="用户名" />
      </div>
      <div class="loginText flexStart">
        <img :src="getResourcesByName('login/password.png')" /><input type="password" name="password" v-model="password"
          placeholder="密码" />
      </div>
      <span class="loginButton nomalButton" @click="loginButton">登 录</span>
      <span class="errorMsg" v-if="errorMsg != ''"><img
          :src="getResourcesByName('login/error.png')" />&nbsp;&nbsp;{{errorMsg}}</span>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    components: {},
    props: [],
    data () {
      return {
        userCode: '',
        password: '',
        errorMsg: '',
        //是否使用背景视频
        backgroundIsVideo: true
      }
    },
    created () {
      debugPage=this
      if(this.$store.menuStore.state.showLeftMenu) {
        //每次F5都清空数据
        this.$store.menuStore.commit('clear')
        this.$api.userApi.logout(respon => {
          //清理所有缓存
          toLogin()
        })
      }
      //初始化配置
      this.$store.menuStore.state.menuType=1
      //FIXME 测试时自动登录
      // this.test()
    },
    mounted () {
    },
    destroyed () {},
    computed: {
      title () {
        if(this.webConfig==undefined) {
          return ''
        }
        document.title=this.webConfig.Title
        return this.webConfig.Title
      },
      loginHeight () {
        return {
          'height': ''+this.height/100+'rem'
        }
      },
      webConfig () {
        return this.$store.cacheStore.getters.getWebConfig
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getColorStyleById () {
        return this.$store.resourcesStore.getters.getColorStyleById
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      getClassName () {
        return this.$store.resourcesStore.getters.getClassName
      },
      getLoginBg () {
        return this.backgroundIsVideo? {}:{
          'background-image': 'url(../../static/unitInformation/loginBg.png)',
          'background-size': '100% 100%',
          'background-repeat': 'no-repeat'
        }
      },
    },
    watch: {
      userCode (nv,ov) {
        this.errorMsg=""
      },
      password (nv,ov) {
        this.errorMsg=""
      },
    },
    methods: {
      test () {
        this.userCode='order'
        this.password='1'
        enableWedoLog()
        this.loginButton()
        //调试的
        setTimeout(() => {
          this.$router.push("/usePowerDifference")
        },4000)
      },
      loginButton () {
        //登录
        this.$api.userApi.login(this.userCode,hex_md5(this.password),"Web",null,respon => {
          //获取用户信息
          this.$store.userStore.commit("setNowUserCode",this.userCode)
          //获取用户单位信息
          this.$store.unitStore.commit("getUnitTree")
          this.$dialogMethod.showMessage('登录成功，正在跳转。。。')
          setTimeout(() => {
            //获取菜单并且进入主界面
            this.$store.menuStore.commit("getMenuList")
          },1000)
          console.log(respon.webSocketUrl,'respon.webSocketUrl');
          //连接新后台
          this.$wedoWebSocketClient.connect(respon.webSocketUrl,respon.pkid)
        },respon => {
          this.errorMsg=respon
        })
      },
    }
  }
</script>

<style scoped>
  .loginContent input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    height: 27px !important;
    line-height: 27px !important;
    border-radius: 0 4px 4px 0;
  }

  .unitTitle {
    margin-top: 5%;
    margin-left: 5%;
    margin-bottom: 3%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 500px;
    z-index: 1;
  }

  .errorMsg {
    display: flex;
    align-items: center;
    width: 89%;
    margin-left: 5px;
    margin-top: 15px;
  }

  .loginText {
    margin-top: 20px;
    border: 1px solid #d6d6d6;
    padding: 2%;
    width: 85%;
    border-radius: 5px;
  }

  .loginText img {
    width: 20px;
    height: 20px;
  }

  .loginText input {
    outline: none;
    width: calc(100% - 25px);
    height: 27px !important;
    line-height: 27px !important;
    font-size: 16px;
    margin-left: 5px;
  }

  .loginButton {
    cursor: pointer;
    margin-top: 20px;
    font-size: 20px;
    width: 89%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loginTitle {
    width: 89%;
    font-size: 30px;
    line-height: 35px;
  }

  .cnTitle {
    font-size: 36px;
    letter-spacing: 13px;
  }

  .loginBody {
    min-width: 1366px;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex !important;
    justify-content: space-between !important;
  }

  .loginContent {
    width: 350px;
    background-color: rgba(255, 255, 255, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 12%;
    right: 20px;
    padding: 30px;
    border-radius: 10px;
  }

  .videoBg {
    background: white;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    overflow: hidden;
  }

  .videoPlayer {
    width: 100%;
  }

  .qrcode {
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-right: 15px;
  }

  .qrcode>img {
    width: 80px;
    height: 80px;
  }

  .qrcode>p {
    color: white;
    text-align: center;
  }

  .information {
    position: absolute;
    z-index: 1;
    bottom: 20px;
    left: calc(50% - 100px);
  }

  .information>p {
    color: #bbb;
    font-size: 14px;
    text-align: center;
  }
</style>